import * as React from "react";
import uncheck from '../../../resources/img/checkbox/checkbox_unchecked.png'
import check from '../../../resources/img/checkbox/checkbox_checked.png'
import SecondLayer from "../../container/second_layer";
import ReportContainer from "./report_container";
import Wait from "../../wait";
import {SpatialService} from "../../../service/v1/spatial";
import {ReportService} from "../../../service/v1/report";
import CCROUploadShpPane from "../../add/ccro_upload_shp";
import PopDetail from "../../popdetail";
import ReportFilterPane from "./report_filter";


export default class ReportListPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            reports: [],
            syncBtn: 'Sync All',
            current_tab: 0,
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 20
        }

        ReportListPane.self = this
        this.getReportList = this.getReportList.bind(this)
    }

    getReportList() {
        try {
            Wait.show('Loading Report List...')
            ReportService.fetchReportList().then(r => {
                Wait.dismiss()
                try {
                    let reports = []
                    r.data.results.forEach(d => reports.push(d))
                    console.log(r.data)
                    ReportListPane.self.setState({
                        reports: [...reports],
                    })
                } catch (e) {
                    console.log(e)
                }

            })
            Wait.dismiss()
        } catch (e) {
            alert(e)
            Wait.dismiss()
        }
    }

    componentDidMount() {
        this.getReportList()
    }

    static self;

    render() {
        return (<div style={{
                width: '98.9%', margin: '4px', border: '1px solid #dddd', padding: '4px',
                height: '90vh', borderTop: '1px solid #efefef', overflowX: 'hidden', overflowY: 'auto'
            }}>
                <div className={'col col-sm-12'} style={{
                    padding: '4px',
                    background: '#efefef',
                    border: '1px solid #ccc',
                    marginBottom: '4px',
                    width: '99.5%',
                    float: 'left'
                }}>
                    <div className={'row'}>

                        <div className={'col col-sm-1'}></div>
                        <div className={'search-div col col col-sm-4'}>
                            <span className={'fa fa-search'}/>
                            <input name={'search'}/>
                        </div>
                        <div className={'col col-sm-1'}></div>

                        {/*<button className={'btn refresh'} >
                        Search
                    </button>*/}
                    </div>

                </div>

                <div className={'col col-sm-12'}>
                    <table className={'tb'} style={{width: '100%'}}>
                        <thead>
                        <th>No.</th>
                        <th style={{position: 'sticky', left: 0, zIndex: 2}}>Report Name</th>
                        <th style={{width: '150px'}}>Action</th>
                        </thead>
                        <tbody>
                        {
                            this.state.reports.map((d, i) => {
                                return (<tr key={i}>
                                    <td style={{textAlign: 'center', backgroundColor: 'white', width: '4%'}}>
                                        {i + 1}
                                    </td>
                                    <td>
                                        <span style={{color: 'darkcyan'}}>{d.name}</span>
                                    </td>
                                    <td style={{fontSize: '8px'}}>
                                        <button className={'btn-list'} title={'View Report'}
                                                onClick={() => d.filter === null ?
                                                    SecondLayer.show(d.name, <ReportContainer report={d}
                                                                                                    key={new Date().getMilliseconds()}/>)
                                        : PopDetail.showDynamic('Select Filter',<ReportFilterPane report={d}
                                                                                              loadData={()=>this.loadData()} key={new Date()}/>,40, 40)}>
                                            <span className={'fa-solid fa-eye fa-xl'}/>
                                        </button>
                                        <button className={'btn-list'} title={'Download PDF'}
                                                onClick={() => ReportContainer.downloadReport(d.endpoint, 'pdf')}>
                                            <span className={'fa-solid fa-file-pdf fa-xl'}/>
                                        </button>
                                        <button className={'btn-list'} title={'Download EXCEL'}
                                                onClick={() => ReportContainer.downloadReport(d.endpoint, 'excel')}>
                                            <span className={'fa-solid fa-file-excel fa-xl'}/>
                                        </button>
                                    </td>
                                </tr>)
                            })
                        }

                        <tr>
                            <td className={'noHover'} colSpan={7} style={{textAlign: 'center'}}>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize - 20
                                    })
                                    this.fetchProjectsByUrl(this.state.previous)
                                }} className={'btn default'}
                                        style={{visibility: this.state.previous !== null ? 'visible' : 'hidden'}}>Back
                                </button>
                                <b>{this.state.totalPages === 0 ? 0 : (this.state.pageSize) / 20}/{this.state.totalPages}</b>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize + 20
                                    })
                                    this.fetchProjectsByUrl(this.state.next)
                                }} className={'btn default'}
                                        style={{visibility: this.state.next !== null ? 'visible' : 'hidden'}}>Next
                                </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                </div>
            </div>
        )
    }

}